export default __webpack_public_path__ + "navigation-camera-bearing-smoothing-enabled-960-af4ed1346d2608b034a72f52ba0be0a7.webp";